import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[symDynamicLoading]',
})
export class DynamicLoadingDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
